import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Navigate } from 'react-router';
import { Link } from 'react-router-dom';
import { addTodo, inittodoFBNoId } from '../redux/actions';
import { credsType, signIn, signUp } from '../redux/authActions';

type inittodo = {
    createdAt: string,
    title: string,  desc: string,  todoId: number,    
    userId: number,    completed: string,   tags: string
}

type initstate = {
    email: string, password: string
}

interface Props {
    formType: string, 
    genderStyle?: string, 
    signIn: Function, 
    signUp: Function, 
    addTodo: Function,
    Uid: string, 
    Uem: string,    
}

interface State {
    input: object | initstate | any, 
    navigateListener: boolean, 
}


class UserForm extends PureComponent<Props, State> {

    initialState: object | initstate;
    inputmail: React.RefObject<HTMLInputElement>;
    dt: Date;
    initialTodo: inittodo;
    signListen: number;
    newVal: string;

    constructor(props: Props){
        super(props);
        this.initialState = { email: '', password: '' };
        this.inputmail = React.createRef<HTMLInputElement>();
        this.dt = new Date();
        this.initialTodo = { 
        createdAt: this.dt.toLocaleString().substring( 0, this.dt.toLocaleString().indexOf(",") ), 
        title: 'first todo item',  desc: 'this is your first todo , can delete it and also edit and add more todos',  todoId: 1,    
        userId: 1,    completed: 'false',   tags: 'todo redux'
        };    
        this.signListen = 0;
        this.newVal = '';
        this.state = {
            input: this.initialState,
            navigateListener: false
        }
    }

    handleChange = (e: any) => {
        this.setState({ ...this.state, input: {email: e.target.value, password: ''+e.target.value+'159'} });
    };
    
    handleSubmit = (e: any) => {
        e.preventDefault();
        this.setState({ ...this.state, navigateListener: false });

        const handelLogIn = (mailVal: string, stateInput: initstate ) => {
            if( mailVal.match(/^[a-z0-9-]+(\@[a-zA-Z-]{3,})+(?:\.[a-zA-Z-]{3,})*$/)){
                this.props.signIn(stateInput);
                this.inputmail.current!.placeholder = '';
                this.inputmail.current!.classList.remove('handelInputError');
                this.setState({ ...this.state , navigateListener: true });
                if( stateInput.email !== this.props.Uem && this.state.navigateListener === false ){
                    this.inputmail.current!.placeholder = 'Email or user name not correct';
                    this.inputmail.current!.classList.add('handelInputError');
                }            
            }
        }

        const handelSignUp = (mailVal: string, stateInput: initstate ) => {
            if( mailVal.match(/^[a-z0-9-]+(\@[a-zA-Z-]{3,})+(?:\.[a-zA-Z-]{3,})*$/)){
                this.props.signUp(stateInput);
                const dt = new Date();
                const initialTodo = { 
                    createdAt: dt.toLocaleString().substring( 0, dt.toLocaleString().indexOf(",") ), 
                    title: 'first todo item',  desc: 'this is your first todo , can delete it and also edit and add more todos',  todoId: 1,    
                    userId: 1,    completed: 'false',   tags: 'todo redux'
                };    
                this.props.addTodo(initialTodo, stateInput.email);
                this.signListen = 1;
                console.log(this.signListen);
                if( this.signListen === 1 ){
                    this.props.signIn(stateInput);
                    this.signListen = 2;
                    this.setState({ ...this.state , navigateListener: true });
                }
            } 
        }

        const handelUppercase = (mailVal: string) => {
            for( let i = 0; i<mailVal.length; i++ ){
                if( mailVal.charCodeAt(i) >= 65 && mailVal.charCodeAt(i) <= 90 ){ return false; }                
            }            
            return true;
        }

        if( this.inputmail.current!.value.length <= 5){
            this.inputmail.current!.placeholder = 'Email or user name must larger 5 digits';
            this.inputmail.current!.classList.add('handelInputError');
        }  

        if( this.inputmail.current!.value.indexOf('@') === -1 && this.inputmail.current!.value.length > 12 ){
            this.inputmail.current!.placeholder = 'user name must smaller than 13 chars';
            this.inputmail.current!.classList.add('handelInputError');
        }

        if( this.inputmail.current!.value.indexOf('@') !== -1 && this.inputmail.current!.value.slice(0, this.inputmail.current!.value.indexOf("@")).length > 12 ){
            this.inputmail.current!.placeholder = 'email must smaller than 13 chars';
            this.inputmail.current!.classList.add('handelInputError');
        }
        
        const handelUppercaseRtn = handelUppercase(this.inputmail.current!.value);
        console.log( handelUppercaseRtn );
        
        if( handelUppercaseRtn === false ){
            this.inputmail.current!.placeholder = `Email or user name don't allow uppercase`;
            this.inputmail.current!.classList.add('handelInputError');
        }

        if( this.props.formType === 'logIn' && handelUppercaseRtn === true ){
            handelLogIn( this.inputmail.current!.value, this.state.input );
            if( ! this.inputmail.current!.value.match(/^[a-z0-9-]+(\@[a-zA-Z-]{3,})+(?:\.[a-zA-Z-]{3,})*$/)
            && this.inputmail.current!.value.match(/^([a-z0-9-]{5,12})$/) ){     
                    this.newVal = ''+this.inputmail.current!.value+'@ggg.ccc';
                    const creds = {email: ''+this.inputmail.current!.value+'@ggg.ccc', password: ''+this.inputmail.current!.value+'@ggg.ccc159'};
                    handelLogIn( this.newVal, creds );
            }
        }

        if( this.props.formType === 'signUp' && handelUppercaseRtn === true ){
            this.signListen = 0;            
            console.log(this.signListen);
            console.log( this.state.input );
            if( this.inputmail.current!.value.match(/^([a-z0-9-]{5,12})$/) ){
                this.newVal = ''+this.inputmail.current!.value+'@ggg.ccc';
                console.log(this.newVal);    
                const creds = {email: ''+this.inputmail.current!.value+'@ggg.ccc', password: ''+this.inputmail.current!.value+'@ggg.ccc159'};
                handelSignUp( this.newVal, creds ) ;
            }
            handelSignUp( this.inputmail.current!.value, this.state.input );
        }

        e.target.reset();
    };


    render(){
        const { formType, genderStyle, signIn, signUp, addTodo, Uid, Uem } = this.props;
        
        if( formType === 'logIn' && Uid && this.state.navigateListener === true ){
            let credsEmail = '';
            let inputVal = this.state.input.email;
            console.log( inputVal, this.state.input.email );            
            if( inputVal.match(/^([a-z0-9-]{5,12})$/) ){
                credsEmail = ''+this.state.input.email+'@ggg.ccc'; 
                console.log( credsEmail , Uem );
                if( credsEmail === Uem ){ 
                    this.setState({ input: this.initialState, navigateListener: true });
                    return( <Navigate to="/reactTodo" replace={true} /> ) 
                }        
            }
            if( inputVal.match(/^[a-z0-9-]+(\@[a-zA-Z-]{3,})+(?:\.[a-zA-Z-]{3,})*$/) ){
                credsEmail = this.state.input.email; 
                console.log( credsEmail , Uem );                
                if( credsEmail === Uem ){ 
                    this.setState({ input: this.initialState, navigateListener: true });
                    return( <Navigate to="/reactTodo" replace={true} /> ) 
                }        
            }
        }
        if( formType === 'signUp' && this.state.navigateListener === true && Uid && this.signListen === 2 ){
            let credsEmail = '';
            let inputVal = this.state.input.email;
            console.log( inputVal, this.state.input.email );            
            if( inputVal.match(/^([a-z0-9-]{5,12})$/) ){
                credsEmail = ''+this.state.input.email+'@ggg.ccc'; 
                console.log( credsEmail , Uem );
                if( credsEmail === Uem ){ 
                    this.setState({ input: this.initialState, navigateListener: true });
                    return( <Navigate to="/reactTodo" replace={true} /> ) 
                }        
            }
            if( inputVal.match(/^[a-z0-9-]+(\@[a-zA-Z-]{3,})+(?:\.[a-zA-Z-]{3,})*$/) ){
                credsEmail = this.state.input.email; 
                console.log( credsEmail , Uem );                
                if( credsEmail === Uem ){ 
                    this.setState({ input: this.initialState, navigateListener: true });
                    return( <Navigate to="/reactTodo" replace={true} /> ) 
                }        
            }
        }
    
        return (        
            <section className={`user-form ${formType} ${genderStyle}`}>
                <h2> 
                    <div id='AzTodos'>
                        <h1>AZ Todos</h1> 
                    </div>
                    {
                        (formType === 'logIn')
                        ?   <p> Log In </p>
                        :   <p> Sign Up </p>
                    }
                </h2>

                <h3>Type Email or User-name To Use App</h3>
                <form onSubmit={this.handleSubmit}>
                    <label htmlFor="email">Email / User-name</label>
                    <input type='text' autoComplete="off" onChange={this.handleChange} name="email" ref={this.inputmail} placeholder='Type your email or user name'/>
                    
                    <label htmlFor="password">Password</label>
                    <input type="password" autoComplete="off" name="password"/>

                    {
                        (formType === 'logIn') && 
                        <div>
                            <button type="submit">Log in</button>                
                            <p>not have an accout ! <Link to='/reactTodoSignUp'> Let's SignUp </Link> </p>                    
                        </div>
                    }
                    {
                        (formType === 'signUp') && 
                        <div>
                            <button type="submit">Sign Up</button>
                            <p>have an accout ! <Link to='/reactTodoSignIn'> Login now </Link> </p>
                        </div>
                    }
                </form>
            </section>
        )
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return{
        signIn : (creds: credsType) => dispatch( signIn(creds) ),
        signUp : (creds: credsType) => dispatch( signUp(creds) ),
        addTodo : (initialTodo: inittodoFBNoId, usem: string) => dispatch(addTodo(initialTodo, usem))
    }
}

const mapStateToProps = (state: any) => {
  const uem = state.firebase.auth.email;
  const uid = state.firebase.auth.uid;
  return{ Uem: uem, Uid: uid }
};

export default connect(mapStateToProps, mapDispatchToProps )( UserForm );
